import { LayoutModule } from "@angular/cdk/layout";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EpdkCommonModule } from "@epdk/ep-common.module";
import { FEATURE_FLAGS_STATE } from "@epdk/util/tokens";
import { environment } from "../../../environment";
import { EP_WWW_CLIENT_FEATURE_FLAGS_STATE } from "../../pages/supplier/ep-www-client-feature-flag.token";
import { FooterComponentModule } from "../../shared/ui/footer/footer.component.module";
import { HeaderComponentModule } from "../../shared/ui/header/header.component.module";
import { AppRootComponent } from "./app-root.component";
import { AppRootRoutingModule } from "./app-root.routing.module";
import { publicCommonProviders } from "../../shared/public-providers";
import { SpxButtonComponentModule } from '../../shared/ui/spx-button/spx-button.component.module';

@NgModule({
  declarations: [AppRootComponent],
  imports: [
    AppRootRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    // This is here for the forms until we convert them
    // but with actual lazy loading now, its only loaded on those forms.
    EpdkCommonModule,
    FooterComponentModule,
    HeaderComponentModule,
    HttpClientModule,
    LayoutModule,
    SpxButtonComponentModule
  ],
  providers: [
    {
      provide: "captchaKey",
      useValue: environment.captchaKey,
    },
    {
      provide: "turnstileSiteKey",
      useValue: environment.turnstileSiteKey,
    },
    {
      provide: "cmsBaseUrl",
      useValue: environment.cmsBaseUrl,
    },
    {
      provide: "storageBucketBaseUrl",
      useValue: environment.storageBucketBaseUrl,
    },
    {
      provide: 'contentHubEnabled',
      useValue: environment.contentHubEnabled
    },
    ...publicCommonProviders(environment),
    {
      provide: FEATURE_FLAGS_STATE,
      useExisting: EP_WWW_CLIENT_FEATURE_FLAGS_STATE,
    },
  ],
  bootstrap: [AppRootComponent],
})
export class AppRootModule {}
